import Cookies from 'js-cookie';

export const tokenState = () => ({
  isVisible: false,
  message: '',
});

export const actions = {
  openErrorDialog({ commit }: any, message: string) {
    commit('openErrorDialog', message);
  },
  closeErrorDialog({ commit }: any) {
    commit('closeErrorDialog');
  },
};

export const mutations = {
  openErrorDialog(state: any, message: string) {
    state.message = message;
    state.isVisible = true;
  },
  closeErrorDialog(state: any) {
    state.message = '';
    state.isVisible = false;
  },
};

export default {
  namespaced: true,
  state: tokenState,
  actions,
  mutations,
};
